import { render } from "./AnimatedComponent.vue?vue&type=template&id=15db10a8&scoped=true"
import script from "./AnimatedComponent.vue?vue&type=script&lang=js"
export * from "./AnimatedComponent.vue?vue&type=script&lang=js"

import "./AnimatedComponent.vue?vue&type=style&index=0&id=15db10a8&lang=sass&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15db10a8"]])

export default __exports__